export default "__VITE_ASSET__1a188de3__"